import React, {Component} from 'react';
import {Row, Col, Table, Breadcrumb, Button, Modal, Form, Input, message, Alert} from 'antd';
import {Link} from 'react-router-dom';
import {api, app} from "../../app";
import utils from "../../utils";

const FormItem = Form.Item;
const {TextArea} = Input;

class List extends Component {
    constructor(props) {
        super(props);
        const class_id = props.match.params.id;
        this.state = {
            problemList: [],
            data_loading: true,
            add_visible: false, //添加对话框是否可见
            reply_visible: false,   //回复对话框是否可见
            add_loading: false, //添加加载
            reply_loading: false,   //回复加载
            class_id: class_id,
            reply_index: 0,    //回复信息下标
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            token: app.getData('token'),
            reply_content: '',   //回复内容
        };
    }

    componentDidMount() {
        this._isMounted = true;
        this.dataSource();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * 数据源
     */
    dataSource() {
        const _this = this, params = {
            class: this.state.class_id,
            indexno: this.state.indexno,
            account: this.state.account,
            token: this.state.token,
        };
        app.post(api.ProblemsList, params).then(({flag, data, msg}) => {
            if (_this._isMounted) {
                if (flag === 1) {
                    _this.setState({problemList: utils.addArrayKey(data)});
                } else {
                    app.alert(msg, "error");
                }
                _this.setState({data_loading: false});
            }
        });
    }

    /**
     * 点击某行
     * @param record
     * @param index
     * @param event
     */
    handleRowClick = (record) => {
        console.log(record);
        const _this = this, data = {
            problems_id: record.id,
            indexno: this.state.indexno,
            account: this.state.account,
            token: this.state.token,
        };
        app.post(api.ProblemsDetails, data).then(({flag, data, msg}) => {
            if (_this._isMounted) {
                if (flag === 1) {
                    _this.showReplyModal();
                    _this.setState({problem: data});
                } else {
                    app.alert(msg, "error");
                }
            }
        });
    }

    /**
     * 显示添加对话框
     */
    showAddModal = () => {
        this.setState({
            add_visible: true,
        });
    }

    /**
     * 隐藏添加对话框
     */
    hideAddModal = () => {
        this.setState({
            add_visible: false, add_loading: false
        });
    }

    /**
     * 显示回复对话框
     */
    showReplyModal = () => {
        this.setState({
            reply_visible: true
        });
    }

    /**
     * 隐藏回复对话框
     */
    hideReplyModal = () => {
        this.setState({
            reply_visible: false, reply_loading: false
        });
    }

    /**
     * 提交新增
     * @param e
     */
    handleAddSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                if (this.state.add_loading) return false;
                this.setState({add_loading: true});
                values.class = this.state.class_id;
                values.token = this.state.token;
                values.indexno = this.state.indexno;
                values.account = this.state.account;
                const _this = this;
                app.post(api.FeedbackProblemsAdd, values).then(({flag, data, msg}) => {
                    if (_this._isMounted) {
                        _this.hideAddModal();
                        _this.props.form.resetFields();
                        if (flag === 1) {
                            _this.setState({data_loading: true});
                            _this.dataSource();
                            app.alert('提交成功', 'success');
                        } else {
                            app.alert(msg, 'warn');
                        }
                    }
                });
            }
        });
    }

    /**
     *
     * @param e
     */
    handlReplyChange = (e) => {
        const {value} = e.target;
        if (value) {
            this.setState({reply_content: value});
        }
    }

    /**
     * 回复
     */
    handleReply = () => {
        if (this.state.reply_loading) return false;
        this.setState({reply_loading: true});
        const problem = this.state.problem, data = {
            problems_id: problem.id,
            token: this.state.token,
            indexno: this.state.indexno,
            account: this.state.account,
            content: this.state.reply_content
        }, _this = this;
        app.post(api.Answer, data).then(({flag, data, msg}) => {
            if (_this._isMounted) {
                _this.setState({reply_loading: false});
                if (flag === 1) {
                    app.alert('回复成功', 'success');
                } else {
                    app.alert(msg, 'warn');
                }
            }
        });
    }

    render() {
        const cloumns = [
            {
                title: '反馈主题',
                dataIndex: 'title',
                key: 'title',
                width: '60%'
            },
            {
                title: '回复数',
                dataIndex: 'count',
                key: 'count',
                width: '10%',
                render() {
                    return 10;
                }
            },
            {
                title: '反馈人',
                dataIndex: 'vname',
                key: 'vname',
                width: '15%'
            },
            {
                title: '反馈时间',
                dataIndex: 'create_time',
                key: 'create_time',
                width: '15%'
            }
        ], state = this.state, loading = state.data_loading, problemList = state.problemList || [], locale = {
            filterTitle: '筛选',
            filterConfirm: '确定',
            filterReset: '重置',
            emptyText: loading ? '正在加载中...' : '暂无人提出问题',
        }, {getFieldDecorator} = this.props.form, problem = state.problem;
        return (
            <div id="feedback_content">
                <div className="top-title">反馈问题<span>Feedback problem</span></div>
                <Breadcrumb separator=">" className="breadcrumb">
                    <Breadcrumb.Item><Link to="/">首页</Link></Breadcrumb.Item>
                    <Breadcrumb.Item><Link to="/feedback">反馈</Link></Breadcrumb.Item>
                    <Breadcrumb.Item>反馈问题</Breadcrumb.Item>
                </Breadcrumb>
                <Row className="problem_list">
                    <Row type="flex" justify="end" style={{marginBottom: 10}}><Button icon="plus"
                                                                                      onClick={this.showAddModal}>新增反馈</Button></Row>
                    <Table size="middle" locale={locale} pagination={false} columns={cloumns} dataSource={problemList}
                           loading={loading} onRowClick={this.handleRowClick}>
                    </Table>

                    <Modal
                        title={(<div className="feedback_modal_title">新增反馈问题<span>（直接向我们提交您宝贵的建议！）</span></div>)}
                        visible={state.add_visible}
                        onOk={this.handleAddSubmit}
                        onCancel={this.hideAddModal}
                        okText="提交"
                        cancelText="取消"
                        maskClosable={false}
                        confirmLoading={state.add_loading}
                    >
                        <Alert style={{marginBottom: 25}} message='反馈的问题通过审核会在相关问题里面展示出来，其他队员看到也可以进行回复' type="info"
                               showIcon></Alert>
                        <Form ref="form" layout="vertical" onSubmit={this.handleAddSubmit}>
                            <FormItem
                                label="反馈主题"
                            >
                                {
                                    getFieldDecorator('title', {
                                        rules: [{required: true, message: '请输入反馈主题!'}],
                                    })(
                                        <Input onPressEnter={this.handleAddSubmit} maxLength={100}/>
                                    )
                                }
                            </FormItem>
                            <FormItem
                                label="反馈详细内容"
                            >
                                {
                                    getFieldDecorator('content', {
                                        rules: [{required: true, message: '请输入反馈详细内容!'}],
                                    })(
                                        <TextArea rows={12} onPressEnter={this.handleAddSubmit} maxLength={600}/>
                                    )
                                }
                            </FormItem>
                        </Form>
                    </Modal>

                    <Modal
                        title={(<div className="feedback_modal_title">问题详情</div>)}
                        visible={state.reply_visible}
                        onOk={this.handleReply}
                        onCancel={this.hideReplyModal}
                        okText="回复"
                        cancelText="取消"
                        confirmLoading={state.reply_loading}
                        width="40%"
                        style={{height: "calc(100% - 20px)", top: 20}}
                        className="feedback_reply"
                    >
                        {problem ?
                            (<Row className="feedback_reply_content">
                                <Row type="flex" className="item">
                                    <Col span={4}>主题</Col>
                                    <Col span={20}>{problem.title}</Col>
                                </Row>
                                <Row type="flex" className="item">
                                    <Col span={4}>问题详情</Col>
                                    <Col span={20} className="detail">{problem.content}</Col>
                                </Row>
                                <Row className="feedback_detail">
                                    {
                                        problem.answer.map((answer, index) => {
                                            return (
                                                <Row key={index + 1} type="flex" className="item">
                                                    <Col span={6}>{answer.answer_name}</Col>
                                                    <Col span={18}>{answer.content}</Col>
                                                </Row>
                                            )
                                        })
                                    }
                                </Row>
                                <Row className="reply-content">
                                    <p>回复问题</p>
                                    <TextArea rows={4} placeholder="请输入您回复的内容~"
                                              onChange={this.handlReplyChange}></TextArea>
                                </Row>
                            </Row>) : ''}
                    </Modal>
                </Row>
            </div>
        );
    }
}

export default Form.create()(List);



// WEBPACK FOOTER //
// ./src/routes/feedback/List.jsx